/* eslint-disable */
import Vue from 'vue';
import nprogress from 'nprogress';
import 'nprogress/nprogress.css';
import store from '@/store';
import Router from 'vue-router';
import routes from './routes';

Vue.use(Router);

let vueRouter = new Router({
  mode: "history",
  routes
});

nprogress.configure({showSpinner: false});

vueRouter.beforeEach((to, from, next) => {
  let nextRouter = [
    "/",
    "admin",
    "dishModel",
    "trainTask",
    "trainModel",
    "batchList",
    "checkList",
    "bindCanteen",
    "dishModelManagement",
    "dishCheck",
    "dishCheckProcess",
    "markProcess",
    "checkProcess",
    "eventManagement",
    "canteenAdmin",
    "detectedImageCheck",
    "machineAdmin",
    'taskAdmin',
    'regionsManage',
    'moduleAdmin',
    'ffi'
  ];
  let superUserRouter = ["canteenAdmin", 'eventManagement', 'batchUpload', 'analysis', 'regionsManage', 'moduleAdmin'];
  let subUserRouter = ["dishCheckProcess", "dishCheck", "bindCanteen"];
  let checkerRouter = ['checkProcess'];
  nprogress.start();
  if (nextRouter.indexOf(to.name) >= 0) {
    if (!store.getters.userinfo().username) {
      vueRouter.push({
        name: "login",
        query: {
          lastRoutesName: to.fullPath
        } });
    }
  }
  console.log(22222222, to.name);

  if (superUserRouter.indexOf(to.name)) {
    if (
      store.getters.userinfo().username &&
      store.getters.userinfo().user_id < 1000
    ) {
      vueRouter.push({ name: "login" });
    }
  }
  console.log(33333, to.name);
  if (subUserRouter.indexOf(to.name)) {
    if (
      store.getters.userinfo().username && store.getters.userinfo().user_id < 100
    ) {
      vueRouter.push({ name: "login" });
    }
  }

  if (to.name === "login") {
    console.log(store.getters.userinfo.username);
    if (store.getters.userinfo().username) {
      vueRouter.push("/taskAdmin");
    }
  }
  next();
});
vueRouter.afterEach(() => {
  console.log(`asddddddddddddd`, nprogress);
  nprogress.done();
});
export default vueRouter;
